<template>
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="923"
    height="637.60452"
    viewBox="0 0 923 637.60452"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="e8d007e8-8581-4ac8-8421-0613b3e5935f-233"
      data-name="Path 133"
      d="M229.669,722.03529a158.3937,158.3937,0,0,0,7.4,43.785c.1.329.211.653.319.982h27.613c-.029-.295-.059-.624-.088-.982-1.841-21.166,8.677-148.453,21.369-170.483C285.17,597.12428,227.528,654.78126,229.669,722.03529Z"
      transform="translate(-138.5 -131.19774)"
      fill="#e6e6e6"
    />
    <path
      id="f8d01cab-c1a6-42c6-a30a-ae051f1ede34-234"
      data-name="Path 134"
      d="M231.741,765.82027c.231.329.471.658.717.982h20.716c-.157-.28-.339-.609-.55-.982-3.422-6.176-13.551-24.642-22.953-43.785-10.1-20.572-19.374-41.924-18.593-49.652C210.836,674.12526,203.844,727.25929,231.741,765.82027Z"
      transform="translate(-138.5 -131.19774)"
      fill="#e6e6e6"
    />
    <path
      id="fd51cc05-38fd-444b-9e70-38f0335b4e21-235"
      data-name="Path 133"
      d="M567.51916,744.05793a80.47349,80.47349,0,0,0,3.75964,22.24541c.05081.16715.1072.33178.16207.49892H585.47c-.01473-.14987-.03-.317-.04472-.49892-.93534-10.75361,4.40844-75.42309,10.85674-86.61567C595.717,680.59559,566.43141,709.88882,567.51916,744.05793Z"
      transform="translate(-138.5 -131.19774)"
      fill="#e6e6e6"
    />
    <path
      id="ef6d185a-ee65-40f0-bfea-de8a051c0d9b-236"
      data-name="Path 134"
      d="M568.57189,766.30334c.11735.16715.2393.33432.36428.49892h10.525c-.07977-.14227-.17223-.30942-.27943-.49892-1.73858-3.13779-6.88472-12.51963-11.66151-22.24541-5.13141-10.45183-9.84316-21.29993-9.44636-25.2262C557.95088,719.71674,554.39854,746.712,568.57189,766.30334Z"
      transform="translate(-138.5 -131.19774)"
      fill="#e6e6e6"
    />
    <polygon
      points="345.964 182.157 310.254 207.557 332.474 209.937 363.424 183.747 345.964 182.157"
      :fill="color"
    />
    <polygon
      points="206.253 615.845 227.731 615.844 237.949 533 206.249 533.001 206.253 615.845"
      fill="#9f616a"
    />
    <path
      d="M339.27394,740.03062l42.29822-.00171h.00171a26.9572,26.9572,0,0,1,26.95574,26.95531v.87595l-69.25439.00257Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M331.24972,451.14262s-9.30846,10.52212,6.10492,51.53862l-2.71492,224.90233,49.95-.97447,10.97957-109.70559,19.99046-160.0916Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M281.37911,415.63963a11.34431,11.34431,0,0,1-11.30957-11.04248l-2.344-88.33789,40.10864-76.09277a11.412,11.412,0,0,1,9.30713-6.03027l30.56641-1.96241-2.63941,178.065-62.69507,5.35839Q281.87411,415.64037,281.37911,415.63963Z"
      transform="translate(-138.5 -131.19774)"
      fill="#bd283e"
    />
    <path
      d="M432.69114,482.23683l-.54688-.0835c-63.8999-9.7456-112.11987-19.08837-112.59949-19.18164l-.599-.11621,16.75085-40.74218c-.13232-4.25733-3.7583-123.80811,3.183-158.15625,6.71961-33.251,38.39356-38.7002,42.00293-39.21289l3.62427-12.00831,45.78735,23.82569,7.9856,27.48388,1.62207,75.32666Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M369.768,368.19774c-29.5,0-53.5-32.07471-53.5-71.5s24-71.5,53.5-71.5,53.5,32.07471,53.5,71.5S399.268,368.19774,369.768,368.19774Zm0-136c-25.64014,0-46.5,28.93457-46.5,64.5s20.85986,64.5,46.5,64.5,46.5-28.93457,46.5-64.5S395.40817,232.19774,369.768,232.19774Z"
      transform="translate(-138.5 -131.19774)"
      fill="#bd283e"
    />
    <path
      d="M460.26829,327.19777a14.94241,14.94241,0,0,0-10.97706,4.80072H372.3303l-28.19043,6.00061,4.62842,35.69867,100.28125-21.56671a14.99351,14.99351,0,1,0,11.21875-24.93329Z"
      transform="translate(-138.5 -131.19774)"
      fill="#9f616a"
    />
    <circle
      cx="428.39015"
      cy="181.45001"
      r="37.09102"
      transform="translate(-141.33196 224.86532) rotate(-45)"
      fill="#9f616a"
    />
    <path
      d="M393.50549,151.79763l-1.79814-3.61914,9.04786-4.49538s9.98123-16.24054,28.04264-11.67659,26.18751,7.29537,26.18751,7.29537l9.025,4.54106-4.52959,4.5068,8.12591,2.73152-5.42868,2.69721,6.31641,3.63055-3.40026,18.61145s-5.6476-14.11607-16.50495-8.72165-30.7171-2.78858-30.7171-2.78858L400.61833,197.9017s-3.55945-11.70537-9.90574-8.58418C390.71249,189.31757,374.49937,163.497,393.50549,151.79763Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M715.79291,380.14583l-1.5852-29.73352-16-13-9.26929,27.53357-51.84253,69.14337a12.99334,12.99334,0,1,0,15.04883,12.82306c0-.17493-.01929-.34491-.02612-.51813Z"
      transform="translate(-138.5 -131.19774)"
      fill="#ffb7b7"
    />
    <polygon
      points="608.103 623.687 595.844 623.686 590.011 576.398 608.105 576.399 608.103 623.687"
      fill="#ffb7b7"
    />
    <path
      d="M749.72989,766.76825l-39.53076-.00147v-.5a15.38731,15.38731,0,0,1,15.38648-15.38623h.001l24.144.001Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <polygon
      points="665.103 623.687 652.844 623.686 647.011 576.398 665.105 576.399 665.103 623.687"
      fill="#ffb7b7"
    />
    <path
      d="M806.72989,766.76825l-39.53076-.00147v-.5a15.38731,15.38731,0,0,1,15.38648-15.38623h.001l24.144.001Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M790.6452,255.93389c5.19051-21.43132,9.588-45.60358-.2009-65.34211-6.792-13.69556-31.91812-18.30762-46.32149-13.37364s-24.81709,18.3202-29.397,32.9154-4.04773,30.32262-2.05161,45.49533C739.16394,255.12,765.65372,254.61114,790.6452,255.93389Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <circle
      cx="745.94295"
      cy="225.03825"
      r="30.88984"
      transform="translate(-155.0298 254.17889) rotate(-28.66321)"
      fill="#ffb8b8"
    />
    <path
      d="M783.70547,218.67511a38.79871,38.79871,0,1,0-77.55078,1.02233C732.59407,219.75358,759.03344,219.80971,783.70547,218.67511Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M696.3389,411.14262s-5.0268,73.01136-2.29883,95.28324,32.42969,216.98328,32.42969,216.98328l22.40457-.04009,6.65133-229.45478,26.494,231.685,23.1696-2.40936,13.14374-226.63s-2.06106-84.84645-18.813-93.35433Z"
      transform="translate(-138.5 -131.19774)"
      fill="#2f2e41"
    />
    <path
      d="M731.48215,483.51662a103.55641,103.55641,0,0,1-47.3103-11.45655l-.32007-.16357,12.38355-82.17188-.80371-97.93359a20.24489,20.24489,0,0,1,20.42993-20.40918l66.45068.60986a21.44432,21.44432,0,0,1,21.18066,23.13672l-6.2185,78.51026,20.5647,63.72363-3.57422,4.75195A103.46153,103.46153,0,0,1,731.48215,483.51662Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M688.75486,355.87111l6.96338-71.05225,2.23779-3.18457a20.24589,20.24589,0,0,1,28.27612-4.87158l1.918,1.36084-1.89331,72.00537Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M974.07963,703.00347c18.00121-4.97253,25.683,22.36344,7.72722,27.4948C963.80649,735.47061,956.12469,708.13464,974.07963,703.00347Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M874.27224,738.18676c18.00121-4.97252,25.683,22.36344,7.72721,27.49481C863.99909,770.6539,856.31729,743.31793,874.27224,738.18676Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M833.87862,449.87926l.27833-.07825,46.36669,125.882,6.113-1.71826L839.93746,447.17986v0a8.57441,8.57441,0,0,0-7.17112-8.01756c-23.188-3.6667-32.58718,16.917-32.58718,16.917l.09278.13684,47.40454,128.69934,6.113-1.7182L807.78,458.28471C821.78683,444.43077,833.87862,449.87926,833.87862,449.87926Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M887.01949,745.26805a31.06163,31.06163,0,0,1-29.45166-22.0332c-8.84912-28.96484-29.729-98.36524-32.4956-117.19922-3.602-24.52246,16.69531-31.49609,17.14746-31.64551.54639-.18359,8.707-2.46777,20.00146-5.6289,19.19922-5.37305,48.21289-13.49317,49.2793-13.97266a34.56208,34.56208,0,0,1,27.57715,2.12988,36.09431,36.09431,0,0,1,17.92578,22.11426l29.86524,106.25293a28.72434,28.72434,0,0,1-15.22315,33.72266c-23.04394,11.07129-56.84131,25.83984-84.17187,26.25683C887.32272,745.26708,887.16988,745.26805,887.01949,745.26805Z"
      transform="translate(-138.5 -131.19774)"
      fill="#bd283e"
    />
    <path
      d="M828.948,445.52514l-15.01323-87.69788-1.67544-29.597-24.27148,7.95016,20.47032,114.83439a12.994,12.994,0,1,0,20.48983-5.4897Z"
      transform="translate(-138.5 -131.19774)"
      fill="#ffb7b7"
    />
    <path
      d="M818.041,352.32667l-37.88306-2.06054-8.90063-71.47852.86621-.75146a21.44517,21.44517,0,0,1,30.31152,2.21728l1.752,2.03809.02563.1289Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <polygon
      points="833.809 570.283 795.089 439.231 704.04 464.962 703.496 463.038 796.447 436.769 796.727 437.717 835.727 569.717 833.809 570.283"
      :fill="color"
    />
    <polygon
      points="145.769 275.046 141.646 185.145 183.878 102.591 185.658 103.502 143.669 185.583 147.767 274.954 145.769 275.046"
      :fill="color"
    />
    <path
      d="M1060.5,768.80226h-921a1,1,0,0,1,0-2h921a1,1,0,0,1,0,2Z"
      transform="translate(-138.5 -131.19774)"
      fill="#ccc"
    />
    <path
      d="M349.261,380.38966,340.45981,354.21l-2.1289-87.26856,3.75-12.38184a34.59343,34.59343,0,1,1,65.33459,22.604l-20.09961,51.50586,1.02173,1.98291,43.5459-.35254,15.468,27.84277Z"
      transform="translate(-138.5 -131.19774)"
      :fill="color"
    />
    <path
      d="M626.66619,566.69l-.0309.00612-48.26445,9.66237-41.51909,16.72023a4.40638,4.40638,0,0,1-5.73343-2.44137q-.07623-.1893-.1347-.385L500.65256,488.69a4.38665,4.38665,0,0,1,2.5761-5.34824l42.27847-17.02612.0309-.00612,48.26443-9.66237,41.5189-16.72017a4.4064,4.4064,0,0,1,5.73345,2.44134q.07623.18932.13471.38507l30.331,101.56224a4.38671,4.38671,0,0,1-2.57605,5.34831Z"
      transform="translate(-138.5 -131.19774)"
      fill="#e5e5e5"
    />
    <path
      d="M574.87481,498.46926c-11.06774-3.90577-22.50733-7.32728-33.99844-10.16918l-.57674-.14259,5.83415,19.53541,29.7237-8.87683Zm-28.28547,8.38009-5.3002-17.74749c10.93729,2.72253,21.82092,5.97047,32.377,9.66116Zm86.28175,18.02777q-7.72815-4.36985-15.67814-8.36921-2.19225-1.10429-4.39783-2.1763-13.46243-6.54942-27.33611-11.9413l-.10806-.042-37.47129,11.1906L558.11245,547.803l75.45248-22.53348ZM558.568,546.95946l-9.84482-32.965,36.59924-10.93017q13.37866,5.20277,26.45164,11.52625,2.26966,1.09707,4.52281,2.22742,7.87349,3.94175,15.546,8.25834Zm74.30308-22.08234q-7.72815-4.36985-15.67814-8.36921-2.19225-1.10429-4.39783-2.1763-13.46243-6.54942-27.33611-11.9413l-.10806-.042-37.47129,11.1906L558.11245,547.803l75.45248-22.53348ZM558.568,546.95946l-9.84482-32.965,36.59924-10.93017q13.37866,5.20277,26.45164,11.52625,2.26966,1.09707,4.52281,2.22742,7.87349,3.94175,15.546,8.25834Zm16.3068-48.4902c-11.06774-3.90577-22.50733-7.32728-33.99844-10.16918l-.57674-.14259,5.83415,19.53541,29.7237-8.87683Zm-28.28547,8.38009-5.3002-17.74749c10.93729,2.72253,21.82092,5.97047,32.377,9.66116Zm28.28547-8.38009c-11.06774-3.90577-22.50733-7.32728-33.99844-10.16918l-.57674-.14259,5.83415,19.53541,29.7237-8.87683Zm-28.28547,8.38009-5.3002-17.74749c10.93729,2.72253,21.82092,5.97047,32.377,9.66116Zm86.28175,18.02777q-7.72815-4.36985-15.67814-8.36921-2.19225-1.10429-4.39783-2.1763-13.46243-6.54942-27.33611-11.9413l-.10806-.042-37.47129,11.1906L558.11245,547.803l75.45248-22.53348ZM558.568,546.95946l-9.84482-32.965,36.59924-10.93017q13.37866,5.20277,26.45164,11.52625,2.26966,1.09707,4.52281,2.22742,7.87349,3.94175,15.546,8.25834Zm-30.85947,16.29092.194.64956,25.65422-7.6615,2.81281,9.41857-25.65423,7.66149.194.64956,26.30378-7.85548-3.20078-10.71769ZM564.805,570.2127l1.96557,6.58164.63161-.2541-1.75364-5.872,100.03168-29.87394-.194-.64955Zm95.92857-45.98205-.194-.64956L559.85833,553.649l3.20078,10.71769,100.68124-30.06793-.194-.64956L563.51468,563.52315l-2.81281-9.41858Zm-74.773-29.13932A330.77671,330.77671,0,0,0,538.842,480.9077l-1.96411-6.57676-.63161.25407,1.97931,6.62767.66441.40056a330.09981,330.09981,0,0,1,46.93562,14.15161l.10807.042L646.815,477.625l-.194-.64956ZM539.44423,508.9832,513.79,516.6447l.194.64956,26.30378-7.85548-9.72552-32.56551-.63162.25407ZM648.5609,483.471l-53.52181,15.984.87159.36584q12.31349,5.1813,24.56261,11.45543,1.74135.89138,3.47923,1.80682,8.64687,4.54119,17.15988,9.58753l.63007.15674,17.05121-5.09225-.194-.64956-17.01026,5.08q-8.42256-4.9982-17.00186-9.51445-1.71591-.90429-3.43633-1.78779-11.99006-6.15872-24.10921-11.299l51.71285-15.44378ZM532.6552,579.81406l.194.64954,25.65423-7.6615,1.9515,6.53453.63161-.25407-2.12754-7.124Zm-16.92533-56.67379.194.64956,25.65423-7.6615,9.84482,32.965-25.65423,7.6615.194.64956,26.30378-7.85548-10.2328-34.26411Zm59.14494-24.671c-11.06774-3.90577-22.50733-7.32728-33.99844-10.16918l-.57674-.14259,5.83415,19.53541,29.7237-8.87683Zm-28.28547,8.38009-5.3002-17.74749c10.93729,2.72253,21.82092,5.97047,32.377,9.66116Zm86.28175,18.02777q-7.72815-4.36985-15.67814-8.36921-2.19225-1.10429-4.39783-2.1763-13.46243-6.54942-27.33611-11.9413l-.10806-.042-37.47129,11.1906L558.11245,547.803l75.45248-22.53348ZM558.568,546.95946l-9.84482-32.965,36.59924-10.93017q13.37866,5.20277,26.45164,11.52625,2.26966,1.09707,4.52281,2.22742,7.87349,3.94175,15.546,8.25834Zm16.3068-48.4902c-11.06774-3.90577-22.50733-7.32728-33.99844-10.16918l-.57674-.14259,5.83415,19.53541,29.7237-8.87683Zm-28.28547,8.38009-5.3002-17.74749c10.93729,2.72253,21.82092,5.97047,32.377,9.66116Zm86.28175,18.02777q-7.72815-4.36985-15.67814-8.36921-2.19225-1.10429-4.39783-2.1763-13.46243-6.54942-27.33611-11.9413l-.10806-.042-37.47129,11.1906L558.11245,547.803l75.45248-22.53348ZM558.568,546.95946l-9.84482-32.965,36.59924-10.93017q13.37866,5.20277,26.45164,11.52625,2.26966,1.09707,4.52281,2.22742,7.87349,3.94175,15.546,8.25834Z"
      transform="translate(-138.5 -131.19774)"
      fill="#fff"
    />
    <path
      d="M583.49269,501.5287c2.45646,8.22536-6.96462,30.99679-6.96462,30.99679s-20.36557-13.87581-22.822-22.10116a15.5433,15.5433,0,1,1,29.78665-8.89563Z"
      transform="translate(-138.5 -131.19774)"
      fill="#bd283e"
    />
    <path
      d="M575.21454,503.29564a7.10552,7.10552,0,1,1-8.84167-4.77509A7.10224,7.10224,0,0,1,575.21454,503.29564Z"
      transform="translate(-138.5 -131.19774)"
      fill="#fff"
      style="isolation:isolate"
    />
    <circle
      cx="440.03926"
      cy="408.06212"
      r="4.18993"
      fill="#bd283e"
    />
    <path
      d="M624.25826,484.16987l-29.11906,8.69625a.6207.6207,0,0,1-.11139.02388l6.64779-27.968a1.00636,1.00636,0,0,1,1.67854-.50128l14.0236,13.24829.67157.63377Z"
      transform="translate(-138.5 -131.19774)"
      fill="#fff"
    />
    <polygon
      points="485.758 352.972 475.816 355.941 478.58 347.395 478.778 346.779 478.878 346.471 479.549 347.105 485.758 352.972"
      opacity="0.2"
      style="isolation:isolate"
    />
    <path
      d="M640.47154,479.32785,615.286,486.8494l2.76336-8.5466.1987-.61556,3.60069-11.13771a1.343,1.343,0,0,1,1.87606-.68466,1.19987,1.19987,0,0,1,.12569.08685Z"
      transform="translate(-138.5 -131.19774)"
      fill="#fff"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default() {
        return ''
      },
    },
  },
}
</script>
